import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import LineOperate from 'kts-scaffold-framework/component/lineOperate';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
// import { MyStore, reducers } from 'kts-platform-frame/redux';
import { create } from 'kts-scaffold-framework/utils/form';
import { Button, Popconfirm, Input, Form, Modal, Select, Tag, TreeSelect } from 'antd'; 
const { TextArea } = Input;
const Option = Select.Option; 
const FormItem = Form.Item;
const css = require('./index.scss'); 

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentWillUnmount () {
        ModulesAction.hideAside();
    }  
    render() {    
        const treeData =  this.modulesState.tagData; 
        const tProps = {   
            treeData: treeData,
            placeholder: "标签", 
            style: {fontSize: '12px'}, 
            multiple: true,
            treeDefaultExpandAll: true,
            allowClear: true,
            treeNodeFilterProp: 'title',
            dropdownClassName:css.treeselecttick,
            dropdownStyle:{ maxHeight: 400, overflow: 'auto' },
            getPopupContainer:() =>  window.document.getElementById('biaoqianss11')
            // filterOption: (inputValue: string, option: any) => { return option.props.children.indexOf(inputValue) !== -1; }
        }; 
        const detail = this.modulesState.statePlatform.detail;
        const isShowRefuseId = this.modulesState.isShowRefuseId; 
        const connectionState = this.modulesState.connectionState;
        const { getFieldDecorator } = this.props.form;
        console.log('init data:', detail.labels);
        return (
            <div className={`${css.detail} searchbtn`}>
                <div className={`${css.head} ${css.center}`}>
                    {
                        detail.imageUrl ? <img className={css['head-avatar']} src={detail.imageUrl}/> : 
                        (
                            <div className={css.icon}>
                                <i className={`${css.icongongsi} anticon anticon-gongsi`}></i>
                            </div>
                        )
                    }
                    <div className={css.title}>{detail.name}</div>
                    <div className={css.button}>
                        { isShowRefuseId ? 
                            <Button 
                                className={`ml-10 kts-but-general ${css.green} ${css.center} ${css.mt20}`} 
                                onClick={this.onAcceptRelation.bind(this, isShowRefuseId)}
                            >接受
                            </Button> : connectionState === 1 ? 
                            <Popconfirm
                                title={
                                    <div>
                                        <div> 您是否确定取消与该公司的网络连接？</div>
                                        <div className={`${css.smtips}`}> 取消连接后该公司将从您公司的网络中移除</div>
                                    </div>
                                } 
                                onConfirm={this.onCancelRelation.bind(this, this.modulesState.visibleWriteConnectionId)} 
                                okText="确定"  
                                cancelText="取消"
                            > 
                                <Button 
                                    style={{height: '28px', marginLeft: '10px'}}
                                    type="default"  
                                    className={`ml-10 ${css.center} ${css.mt20}`} 
                                >取消连接
                                </Button> 
                            </Popconfirm> : 
                            <Button
                                className={`ml-10 kts-but-primary ${css.green} ${css.center} ${css.mt20}`} 
                                onClick={this.onCreateRelation.bind(this, detail)}
                            >连接
                            </Button>
                        } 
                        { isShowRefuseId && <Popconfirm 
                            title={
                                <div>
                                    <div> 确定拒绝该公司的网络连接请求？</div>
                                    <div className={`${css.smtips}`}> 拒绝后该公司将从网络待加入列表中移除</div>
                                </div>
                            }  
                            onConfirm={this.onCancelRelation.bind(this, isShowRefuseId)} 
                            okText="确定" 
                            cancelText="取消"
                        >
                            
                            <Button 
                                style={{height: '28px', marginLeft: '10px'}}
                                type="default"  
                                className={`ml-10 ${css.center} ${css.mt20}`} 
                            >拒绝
                            </Button> 
                        </Popconfirm>}
                    </div>
                </div>
                <div className={css.spaceliner}/>
                <div className={`${css.body} ${css.detailbg} ${css.wraperellipsis}`}> 
                    <div className={css.formitem}>
                        <div className={css.label}>公司税号</div>
                        <div className={css.wrapper}>{detail.taxId || '暂无'}</div>
                    </div>
                    <div className={css.formitem}>
                        <div className={css.label}>所在地区</div>
                        <div className={css.wrapper}>{detail.city || '暂无'}</div>
                    </div>
                    <div className={css.formitem}>
                        <div className={css.label}>所在国家</div>
                        <div className={css.wrapper}>{detail.country || '暂无'}</div>
                    </div>
                    <div className={css.formitem}>
                        <div className={css.label}>联系人</div>
                        <div className={css.wrapper}>{detail.legalEntity || '暂无'}</div>
                    </div>
                    {/* <div className={css.formitem}>
                        <div className={css.label}>邮箱</div>
                        <div className={css.wrapper}>{detail.email || '暂无'}</div>
                    </div> */}
                    {/* <div className={css.formitem}>
                        <div className={css.label}>电话</div>
                        <div className={css.wrapper}>{detail.phone || '暂无'}</div>
                    </div> */}
                    <div className={`${css.spaceliner} ${css.mtb37}`}/> 
                    <div className={`${css.label}`}>公司介绍</div>
                    <div className={`${css.introduction} ${css.mt20}`}>{detail.description || '暂无'}</div>    
                    <div>
                        <Form> 
                            <div className={`${css.spaceliner} ${css.mtb37}`}/> <div>
                            <div className={`${css.label}`} style={{ marginBottom: '25px'}}>标签   <i onClick={ModulesAction.changelabels} style={{cursor: 'pointer'}} className={`anticon anticon-bianji ml-10`}></i></div>
                                <div className={`${css.introduction} ${css.mt20}`}>
                                    {this.modulesState.visiblelabels ? 
                                        <FormItem  colon={false}> 
                                        <div id="biaoqianss11">
                                            {getFieldDecorator('labels', {initialValue: detail.labels && detail.labels.map(item=>item.labelId + '') || []})( 
                                                <TreeSelect {...tProps} />   
                                            )}
                                        </div>
                                    </FormItem> : detail.labels && detail.labels.map((item, index)=><Tag key={index}>{item.labelName}</Tag>)}   
                                    <div style={{textAlign: 'center', marginTop: '10px', paddingBottom: '20px'}}>
                                        {this.modulesState.visiblelabels && <Button onClick={ModulesAction.cancelchangelabels} type="default" >取消</Button>}
                                        {this.modulesState.visiblelabels && <Button className="ml-10" onClick={this.updateTag.bind(this, detail)} type="primary" >保存</Button>} 
                                    </div>
                                </div> 
                            </div> 
                        </Form>
                    </div>
                    <div>
                        <Form onSubmit={this.updateRemark}>
                            <FormItem style={{display: 'none'}} colon={false}> 
                                {getFieldDecorator('connectionId', {initialValue: this.modulesState.visibleWriteConnectionId})( 
                                    <Input />  
                                )}
                            </FormItem>
                            <div className={`${css.spaceliner} ${css.mtb37}`}/> <div>
                            <div className={`${css.label}`} style={{ marginBottom: '25px'}}>备注   <i onClick={ModulesAction.changeRemarkWrite} style={{cursor: 'pointer'}} className={`anticon anticon-bianji ml-10`}></i></div>
                                <div className={`${css.introduction} ${css.mt20}`}>
                                    {this.modulesState.visibleWrite ? 
                                        <FormItem  style={{height: '100px'}} colon={false}> 
                                        {getFieldDecorator('remarkInfo', {initialValue: this.modulesState.remarkTemp || detail.remarkInfo})( 
                                            <TextArea style={{resize: 'none'}} rows={4} />  
                                        )}
                                    </FormItem> : this.modulesState.remarkTemp || detail.remarkInfo|| '暂无'}  
                                    <div style={{textAlign: 'center', marginTop: '10px', paddingBottom: '40px'}}>
                                        {this.modulesState.visibleWrite && <Button onClick={ModulesAction.cancelchangeRemarkWrite} type="default" >取消</Button>}
                                        {this.modulesState.visibleWrite && <Button className="ml-10" htmlType="submit" type="primary" >保存</Button>} 
                                    </div>
                                </div> 
                            </div> 
                        </Form>
                    </div>
                    {/* @杜涛添加公司代码 */}
                    {
                        this.modulesState.tabchange === '1' && (this.modulesState.companyCodeEdit ? 
                        <div className={css['detail-companyCode']}>
                            <LineOperate
                                title="公司代码"
                                operates={
                                    [
                                        {
                                            type: 'baocun',
                                            event: this.saveCompanyCode
                                        },
                                        {
                                            type: 'fanhui',
                                            event: this.noChangCompanyCodeEdit
                                        }
                                    ]
                                }
                            />
                            <Form
                                className={css['detail-companyCode-content']}
                            >
                                <FormItem>
                                    {
                                        getFieldDecorator('companyCode',(
                                            {
                                                initialValue: this.modulesState.companyCodeTemp || detail.companyCode
                                            }
                                        ))
                                        (<Input/>)
                                    }
                                </FormItem>
                            </Form>
                        </div> :
                        <div className={css['detail-companyCode']}>
                            <LineOperate
                                title="公司代码"
                                operates={[
                                    {
                                        type: 'bianji1',
                                        event: this.isChangCompanyCodeEdit
                                    }
                                ]}
                            />
                            <span
                                className={css['detail-companyCode-view']}
                            >
                                {
                                    this.modulesState.companyCodeTemp || detail.companyCode || '暂无'
                                }
                            </span>
                        </div>)
                    }
                    <div className={`${css.spaceliner} ${css.mtb37}`} /> 
                    <div className={`${css.label}`}>公司风采</div>
                    <div className={`${css.introduction} ${css.mt20}`}>
                        <ul className={css.imgList}>
                            {
                                this.modulesState.imgList.length ?
                                this.modulesState.imgList.map((item) => (
                                    <li key={item.imageId} onClick={() => ModulesAction.showEleganceModal(true, item.imgUrl)}>
                                        <img className={css.uploadImg} src={item.imgUrl} alt="" />
                                    </li>
                                )) : '暂无'
                            }
                        </ul>
                    </div>
                    <Modal visible={this.modulesState.showEleganceModal} footer={null} className={css.imgModal} onCancel={() => ModulesAction.showEleganceModal(false)}>
                        <img alt="" style={{ width: '100%' }} src={this.modulesState.imgUrlElegance} />
                    </Modal> 
                </div>
            </div>
        );
    } 
     /** 取消连接 */
    private onCancelRelation = (isShowRefuseId) => {
        ModulesAction.sendCancelRelation({
            connectCompanyId: isShowRefuseId, 
        });
    }
    /** 更改标签 */
    private updateTag = (rec) => { 
        // 更新公司关联的标签 
        this.props.form.validateFields((err, values) => { 
            ModulesAction.setTagToCompany({companyId: rec.companyId, labelIds: values.labels.map(item=> parseInt(item, 10))});
        }); 
    }
    /** 更改公司备注 */
    private updateRemark = (e) => {
        e.preventDefault(); 
        this.props.form.validateFields((err, values) => { 
            if (!err) {
                const options = this.props.form.getFieldsValue(['remarkInfo', 'connectionId']);
                ModulesAction.changeCompanyRemark(options, 0)
                .then(res => {
                    ModulesAction.cancelchangeRemarkWrite();
                });
            }
        }); 
        // this.props.form.resetFields();
    }
    /** 发送连接请求 */
    private onCreateRelation = (rec) => {
        ModulesAction.sendRelation({
            targetCompanyId: rec.companyId,
            targetTaxId: rec.taxId
        });
    }
    /** 接受连接 */
    private onAcceptRelation = (connectionId) => {
        ModulesAction.acceptRelation({
            connectCompanyId: connectionId
        });
    }
    /** 打开编辑公司编码 */
    private isChangCompanyCodeEdit = () => {
        ModulesAction.changeCompanyCodeEdit(true);
    }
    /** 关闭编辑公司编码 */
    private noChangCompanyCodeEdit = () => {
        ModulesAction.changeCompanyCodeEdit(false);
    }

    private saveCompanyCode = () => {
        const options = this.props.form.getFieldsValue(['companyCode', 'connectionId']);
        if (options['companyCode'] === null) {
            options['companyCode'] = '';
        }
        ModulesAction.changeCompanyRemark(options, 1)
        .then(res => {
            this.noChangCompanyCodeEdit();
        });
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/Network/UI.Network.Modal.CompanyDetail.tsx